import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLangFromPath, toggleLangPath } from '../../lib/lang';

/**
 * Small IT / EN pill in the top-right of the header. Clicking either
 * button navigates to the same section under the other language, or
 * stays put if it's already active.
 */
export default function LanguageSwitcher({ variant = 'dark' }) {
    const { pathname } = useLocation();
    const nav = useNavigate();
    const current = getLangFromPath(pathname);

    const switchTo = (target) => {
        if (target === current) return;
        const { path } = toggleLangPath(pathname);
        nav(path);
    };

    return (
        <div
            className={`lang-switch lang-switch--${variant}`}
            data-testid="lang-switch"
            role="group"
            aria-label="Language"
        >
            {['it', 'en'].map((code) => (
                <button
                    key={code}
                    type="button"
                    className={`lang-switch__btn ${
                        current === code ? 'is-active' : ''
                    }`}
                    onClick={() => switchTo(code)}
                    aria-pressed={current === code}
                    data-testid={`lang-switch-${code}`}
                >
                    {code.toUpperCase()}
                </button>
            ))}
        </div>
    );
}
